exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cta-link[data-v-26c4db43]{color:#0018e2}", ""]);

// exports
